import React from 'react';
import { ConnectedRouter } from 'react-router-redux';
import { Route, Switch } from 'react-router';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

import history from './../stores/history';
import config from 'config';

import baseLayout from './shared/layouts/Base';
import WelcomePage from './pages/Welcome';
import CustomizePage from './pages/Customize';
import RestaurantsPage from './pages/Restaurants';
import ReachUsPage from './pages/ReachUs';
import EventsPage from './pages/Events';
import ErrorPage from './pages/Error';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import NewsPage from './pages/News';

// import MailUnsubscribe from './pages/MailUnsubscribe';

import tokenSetter from './shared/TokenSetter';

import './../styles/app.scss';
import DuringStaySurvey from '../components/pages/DuringStaySurvey';

class App extends React.Component {

  componentDidMount() {
    /* Initialize Google Analytics */
    ReactGA.initialize(config.google.analytics.trackingNumber);
    console.log('React GA initialized');
    ReactGA4.initialize([{trackingId: config.google.analytics.trackingNumberGA4}]);
    console.log('React GA4 initialized');
  }

  render() {
    return (
      <ConnectedRouter history={history}>
        <div>
          <Switch>
            <Route path="/welcome/:context(public|hotel)/:token" component={tokenSetter(baseLayout(WelcomePage))}/>
            <Route path="/customize/:context(public|hotel)/:token/:cat_id?" component={tokenSetter(baseLayout(CustomizePage))}/>
            <Route path="/restaurants/:context(public|hotel)/:token" component={tokenSetter(baseLayout(RestaurantsPage))}/>
            <Route path="/reach_us/:context(public|hotel)/:token" component={tokenSetter(baseLayout(ReachUsPage))}/>
            <Route path="/events/:context(public|hotel)/:token" component={tokenSetter(baseLayout(EventsPage))}/>
            <Route path="/news/:context(public|hotel)/:token" component={tokenSetter(baseLayout(NewsPage))}/>

            <Route exact={true} path="/welcome/:token" component={tokenSetter(baseLayout(WelcomePage))}/>
            <Route exact={true} path="/customize/:token/:cat_id?" component={tokenSetter(baseLayout(CustomizePage))}/>
            <Route exact={true} path="/restaurants/:token" component={tokenSetter(baseLayout(RestaurantsPage))}/>
            <Route exact={true} path="/reach_us/:token" component={tokenSetter(baseLayout(ReachUsPage))}/>
            <Route exact={true} path="/events/:token" component={tokenSetter(baseLayout(EventsPage))}/>
            <Route exact={true} path="/news/:token" component={tokenSetter(baseLayout(NewsPage))}/>

            <Route exact={true} path="/privacy_policy/:lang?" component={tokenSetter(baseLayout(PrivacyPolicy))}/>
            <Route exact={true} path="/cookie_policy/:lang?" component={tokenSetter(baseLayout(CookiePolicy))}/>

            { /* <Route path="/mail_unsubscribe/:token" component={tokenSetter(baseLayout(MailUnsubscribe))}/> */ }

            <Route exact={true} path="/during-stay-survey/:token" component={tokenSetter(baseLayout(DuringStaySurvey))} />

            <Route component={ErrorPage}/>
          </Switch>
        </div>
      </ConnectedRouter>
    );
  }
}

App.defaultProps = {};

export default App;



// WEBPACK FOOTER //
// ./components/App.js